/**
 * Parental/guardian consent for uploading a photo that may depict a real person
 * (often a child) to generate a stylized AI character likeness.
 *
 * A child's facial photo is special-category / biometric personal data under
 * GDPR Art. 9 — processing requires the EXPLICIT consent of the holder of
 * parental responsibility. This constant versions the consent text the user
 * affirmed; bump it whenever the consent wording materially changes so a fresh
 * affirmation is required and old records stay auditable.
 *
 * Client- and server-safe (no `server-only`): the wizard checkbox imports the
 * version to submit, the upload action + reference service verify it.
 */
export const PHOTO_CONSENT_VERSION = '1.0.0';
